import Button from 'apollo-react/components/Button';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import NavigateLinkCell from './FindPage/NavigateLinkCell';
import DefaultPageLayout from '../components/DefaultPageLayout';
import Link from '../components/Link';
import SavedSearchesTable from '../components/SavedSearchesTable';
import {
  DOCUMENT_REPOSITORIES_ENTITY_NAME,
  GET_SMARTINSIGHT_REPORTS_ENDPOINT,
  SMARTINSIGHT_REPORT_LIST_SEARCH_NAME,
} from '../constants/SmartInsightConstants';
import { SMART_INSIGHT_REPORTS, SMART_INSIGHT_REPORTS_LIST } from '../constants/Urls';
import { useTranslation } from '../custom-hooks/useTranslation';
import { getHasManageRight } from '../selectors/SmartInsightSelectors';
import { getUITA } from '../utils/commonUtils';

const SmartInsightReportsListPage = () => {
  const translateString = useTranslation();

  const hasManageRight = useSelector(getHasManageRight);

  const pageTitle = translateString('mnuSmartInsightReports');

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const ActionButton = (
    <Button
      variant="secondary"
      component={Link}
      to={SMART_INSIGHT_REPORTS}
      target="_blank"
      ui-ta={getUITA('reports-dashboard')}
    >
      {translateString('SmartInsight Dashboard')}
    </Button>
  );

  return (
    <DefaultPageLayout pageTitle={pageTitle} ActionButton={hasManageRight && ActionButton}>
      <SavedSearchesTable
        showSearchSelector={false}
        customCell={NavigateLinkCell.forUrl(SMART_INSIGHT_REPORTS_LIST, '_blank')}
        entityName={DOCUMENT_REPOSITORIES_ENTITY_NAME}
        enableSorting
        initialSearchName={SMARTINSIGHT_REPORT_LIST_SEARCH_NAME}
        rowsPerPageOptions={[10, 25, 50, translateString('All')]}
        title={translateString('Records')}
        customEndpointName={GET_SMARTINSIGHT_REPORTS_ENDPOINT}
      />
    </DefaultPageLayout>
  );
};

export default SmartInsightReportsListPage;
